import ReactApexCharts from 'react-apexcharts';
import { Box, Flex, GridItem, HStack, Text } from '@cdl/heartbeat-react';
import { AnnotationTask } from '../../../ecg/types/annotation-tasks.type';
import { greyBorder } from '../../../utils/colors';
import { TaskMetricSection } from './TaskMetricSection';

type Props = {
  annotationTask: AnnotationTask;
};

export const TopContributions: React.FC<Props> = ({ annotationTask }) => {
  const options: ApexCharts.ApexOptions = {
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      x: {
        format: 'dd MMM yyyy',
      },
    },
    stroke: {
      curve: 'smooth' as const,
    },
    grid: {
      borderColor: greyBorder,
    },
    series: annotationTask.userCumulCompletions,
    xaxis: {
      type: 'datetime' as const,
      tickPlacement: 'between',
      labels: {
        showDuplicates: false,
        format: 'dd MMM',
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: 'bottom' as const,
      horizontalAlign: 'right' as const,
      itemMargin: {
        horizontal: 14,
        vertical: 0,
      },
    },
  };

  return (
    <GridItem colSpan={1}>
      <TaskMetricSection>
        <Text textStyle='category-title'>Top contributions</Text>
        <Flex direction='column' height='90%'>
          <Box mt='m' flex={1}>
            {annotationTask.userTotalCompletions &&
              annotationTask.userTotalCompletions.length > 0 &&
              annotationTask.userTotalCompletions
                .sort((a, b) => {
                  return b.total - a.total;
                })
                .map((values, index) => (
                  <HStack key={index} spacing='s'>
                    <Text textStyle='small-label'>{values.name}:</Text>
                    {annotationTask.ecgTotalCount &&
                      annotationTask.nbAnnotations && (
                        <Text>
                          {values.total}/
                          {annotationTask.ecgTotalCount *
                            annotationTask.nbAnnotations}
                        </Text>
                      )}
                  </HStack>
                ))}
          </Box>
          <Box mt='auto'>
            <ReactApexCharts
              options={options}
              series={options.series}
              type='line'
              height={250}
            />
          </Box>
        </Flex>
      </TaskMetricSection>
    </GridItem>
  );
};
